import ImageDiffViewer from '~/vue_shared/components/diff_viewer/viewers/image_diff_viewer.vue';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'ImageViewer',
    components: {
        ImageDiffViewer
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        imageData: {
            type: Object,
            required: true
        }
    }
};
